import './IconButtonWithSlider.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickAwayListener } from '@mui/base';
import { Button, Slider } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { MouseEvent as ReactMouseEvent, ReactElement, useState } from 'react';

interface IProps {
  icon: IconProp;
  title?: string;
  disabled?: boolean;
  minRange: number;
  maxRange: number;
  value: number;
  onChange(value: number): void;
  tabIndex?: number;
  popupLabel: string;
}

export const IconButtonWithSlider = observer((props: IProps): ReactElement => {
  const [showSlider, setShowSlider] = useState(false);

  const toggleSlider = (event: ReactMouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    setShowSlider((prevShowSlider) => !prevShowSlider);
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        setShowSlider(false);
      }}
    >
      <div className='btn-with-slider-wrapper'>
        <Button
          variant='outlined'
          color='primary'
          size='sm'
          className={classNames({ selected: showSlider })}
          onClick={toggleSlider}
          title={props.title}
          disabled={props.disabled}
          tabIndex={props.tabIndex ?? 0}
          endDecorator={<FontAwesomeIcon icon={props.icon} />}
        >
          <span className='btn-icon-slider-label'>{props.value}</span>
        </Button>
        {showSlider && (
          <div className='btn-icon-slider'>
            <span>{props.popupLabel}</span>
            <span className='value'>{props.value}</span>
            <Slider
              id='slider'
              name='slider'
              value={props.value}
              min={props.minRange}
              max={props.maxRange}
              step={1}
              onChange={(_, v) => {
                props.onChange(v as number);
              }}
              tabIndex={props.tabIndex}
            />
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
});
